module.exports = __webpack_public_path__ + "img/boy.3c5e9a7c.png";